import { getSchemaNodeAtPath, SchemaNode } from "./node";

// Filter takes in a SchemaNode root graph, and a list of paths that should be
// filtered out. It returns a new SchemaNode graph with the filtered paths removed.
export function Filter(
  input: SchemaNode,
  filters: string[],
): SchemaNode {
  if (filters === undefined) {
    return input;
  }
  if (filters.length === 0) {
    return input;
  }
  // first clone, cause we don't want to modify the original graph
  let clone = input.clone();
  // for each filter, remove the path from the graph
  for (const filter of filters) {
    // remove the path from the graph
    let node = getSchemaNodeAtPath(clone, filter);
    if (node === null) {
      continue;
    }
    // it exists, so remove it
    node.removeSelf()
  }

  return clone;
}